import React, { useState } from "react";
import styled from "styled-components";
import { useToast } from "../../store/ToastProvider";
import { CompassParagraph } from "../../components/common/styledComponents";
import LoginMethod from "../../components/buttons/LoginMethod";
import { CarouselColumn } from "./CarouselColumn";
import { InputCredentials } from "./InputCredentials";
import { PwAndCheckboxLine } from "./PwAndCheckboxLine";
import { LoginButton } from "./LoginButton";

import {
  RowContainer,
  HorizontalLine,
  Column,
} from "../../components/containers/styledComponents";

// assets
import login_bg from "../../assets/images/login_bg.png";
import outlook_icon from "../../assets/svg/outlook_icon.svg";
import gmail_icon from "../../assets/svg/gmail_icon.svg";

const BackgroundContainer = styled.div`
  width: 100%;
  height: 100vh;
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)),
    url(${login_bg}) !important;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-end; // This aligns the Column at the end
  justify-content: flex-start;
`;

const LoginBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 500px;
  height: 80%; // Takes 80% of Column's height
  background: white;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  font-family: "Apercu";
  margin-top: auto; // Pushes itself to the bottom;
`;

const LoginBoxMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
`;

const LineBreakText = styled.div`
  margin-top: -30px;
  font-size: 13px;
  background-color: white;
  padding: 0 12px;
`;

const LoginHeader = styled.p`
  margin-bottom: 20px;
  padding-top: 15px;
  font-size: 24px;
  font-family: "ApercuBold";
`;

export const Login: React.FC = () => {
  const { addToast } = useToast();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  return (
    <BackgroundContainer className="background-container">
      <Column flex="0 0 57%">
        <CarouselColumn />
      </Column>
      <Column flex="0 0 28%">
        <LoginBox>
          <LoginBoxMainContainer>
            <LoginHeader>Log in to your account</LoginHeader>
            <InputCredentials
              usernameProps={{ username, setUsername }}
              passwordProps={{ password, setPassword }}
              loginErrorProps={{ error, setError }}
            />
            <RowContainer>
              <PwAndCheckboxLine />
              <CompassParagraph>Forgot Password?</CompassParagraph>
            </RowContainer>
            <LoginButton
              usernameProps={{ username, setUsername }}
              passwordProps={{ password, setPassword }}
              loginErrorProps={{ error, setError }}
            />
            <RowContainer>
              <HorizontalLine />
            </RowContainer>
            <RowContainer jc="center">
              <LineBreakText>Or</LineBreakText>
            </RowContainer>
            <LoginMethod
              icon={outlook_icon}
              size={35}
              message={"Sign in with SSO"}
              addToast={addToast}
            />
            <LoginMethod
              icon={gmail_icon}
              size={35}
              message={"Sign in with Gmail"}
              addToast={addToast}
            />
          </LoginBoxMainContainer>
        </LoginBox>
      </Column>
    </BackgroundContainer>
  );
};
